export default {

	title: `Le lin, fibre du futur`,

	subTitle: `Objectifs durables`,

	author: `Par Élodie Epaillard, journaliste.`,

	content1: `<strong>Porté par un regain d’intérêt</strong> des consommateurs pour les matières naturelles, le marché du lin est florissant. Et ce n’est qu’un début : au fil des expérimentations, la fibre végétale se révèle être une inépuisable source d’innovation.`,

	content2: `En plus de respecter l’environnement car sa culture ne requiert ni pesticides ni irrigation, <strong>le lin répond aux enjeux actuels de souveraineté</strong> de pays tels que la France, son premier producteur mondial. Ainsi, l’Hexagone a amorcé la relocalisation de la filière avec l’ouverture de trois filatures entre 2020 et 2022 et d’une quatrième d’ici la fin de l’année. La démarche donne des idées à ses voisins également exportateurs : la Belgique et les Pays-Bas. Sur le Vieux Continent, qui produit 80 % de la récolte mondiale, start-up et industriels s’intéressent à ce <strong>matériau recyclable</strong> aux propriétés remarquables.`,

	content3: `Si jusqu’alors, le lin était surtout utilisé dans le domaine du textile, ses applications techniques font désormais l’objet d’investissements en recherche & développement, notamment pour <strong>remplacer le carbone ou le plastique. Léger, solide et doté de qualités vibratoires et isolantes</strong>, le lin se prête à la fabrication de meubles, cannes à pêche, skis, kayaks, cadres de vélos ou encore de profils de fenêtres.`,

	title4: `Les initiatives`,
	content4: `Convaincue du potentiel de la fibre millénaire, l’entreprise normande Eco-Technilin enchaîne les innovations : pièces destinées aux intérieurs des voitures, voilier du navigateur Roland Jourdain, raquette de tennis de Carlos Alcaraz… Elle a même participé à la construction du premier pont au monde fait dans cette matière, à Amsterdam.`,

	content5: `La fibre inspire aussi outre-Manche. L’université de Nottingham a créé un prototype de pales d’éoliennes avec de la mèche de lin. Dans un registre plus terre à terre, des chercheurs écossais ont récemment mis au point une alternative durable à l’huile de palme à partir d’un sous-produit de l’industrie des graines de lin et d’huile de colza.`,

	content6: `L’Agence Spatiale Européenne (ESA) étudie elle aussi la possibilité de renforcer des panneaux satellites avec du lin. Capable de supporter des écarts de températures extrêmes, la fibre permettrait d’échanger des transmissions radio en limitant la déperdition. Surtout, le lin est biodégradable, il se consumerait intégralement dans l’atmosphère terrestre une fois arrivé en fin de vie. Une qualité qui compte à l’heure où le nombre de débris spatiaux est de plus en plus préoccupant.`,


	// KEY FIGURES
	keyFigures: [
		{
			figure: 3.7,
			figureDecimals: 1,
			suffix: `tonnes de CO<sub>2</sub>`,
			content: `Un hectare de lin absorbe 3,7 tonnes de CO2 chaque année. On appelle cela un puits de carbone.`,
			source: `Source : Les savoir-faire du lin textile, Ministère de la Culture 2021.`,
			topImage: `Sustainable_001.svg`,
			noCollapse: true,
		},
		{
			figure: '5 à 10',
			suffix: `fois moins`,
			content: `La production du lin est 5 à 10 fois moins énergivore que celle de la fibre de verre.`,
			source: `Source : <a href="www.sciencesetavenir.fr" target="_blank">www.sciencesetavenir.fr</a>`,
			topImage: `Sustainable_002.svg`,
			noCollapse: true,
		},
	],

}
